import React from 'react';
import Image from "gatsby-image"
// import { GatsbyImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby";
import styled from 'styled-components'
import { rhythm } from "../utils/typography";

import SocialIcons from "./SocialIcons";

const BioBriefDiv = styled.div`
  width:100%;
  padding:${rhythm(1)} ${rhythm(0.75)};
  margin:${rhythm(1)} 0;
  display:flex;
  gap:20px;
  flex-direction:row;
  justify-content:flex-start;
  align-items:center;
  border-bottom: 1.5px solid var(--color-gray3);
  font-size: 16px;
`;

const H3 = styled.strong`
display:block;
font-weight: 500;
font-size:24px;
margin-bottom:4px;
`

const BlogBriefIconDiv = styled.div `
margin:0;
display: flex; 
justify-content:flex-start;
align-items:center;
gap: 2ch;
`;

const BioBrief = ({publishedDate, timeToRead}) => {
  const data = useStaticQuery(graphql`
    query BioBriefQuery {
      avatar: file(absolutePath: { regex: "/profile.jpg/" }) {
        childImageSharp {
            fluid(maxWidth: 130, maxHeight: 130,  ) {
              ...GatsbyImageSharpFluid
            }
          }
      }
      site {
        siteMetadata {
          author {
            name
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author;
  const avatar = data?.avatar?.childImageSharp?.fluid;
    const imgStyles = {
      objectFit: 'contain',
      borderRadius: `50%`,
      margin:0,
      width:'84px',
      height:'84px'
    }
  return (
    <BioBriefDiv>
      <Image
        fluid={avatar}
        alt={author?.name || ``}
        imgStyle={imgStyles}
        style={imgStyles}
        placeholderStyle={imgStyles}

      />
      <div >
          <H3>{author.name}</H3>
          {publishedDate && `Published on ${publishedDate}`}
          <BlogBriefIconDiv>
            <div style={{
              display:"flex",
              gap:"0.5ch"
            }}>
              <SocialIcons/>
            </div>
            <div>
              <span role="img"  aria-label="Time to read">🕐</span> {timeToRead} min read.
            </div>
          </BlogBriefIconDiv>
      </div>
    </BioBriefDiv>
  )
}


export default BioBrief;